import Flatpickr from "stimulus-flatpickr"
import { endOfToday } from "date-fns"

export default class extends Flatpickr {
  static values = {
    timeStart: Boolean,
    timeEnd: Boolean,
  }

  connect() {
    this.config = { ...this.customConfig, ...this.config }

    super.connect()
    if (this.element.dataset.flatpickrNarrow === "true") {
      this.fp.calendarContainer.classList.add("narrow")
    }
  }

  open() {
    if (this.parentPreventingFocus && !document.body.contains(this.parentPreventingFocus)) {
      this.parentPreventingFocus = null
    }

    this.parentPreventingFocus ||= this.findParentPreventingFocus()

    if (this.parentPreventingFocus) {
      this.parentPreventingFocus.removeAttribute("tabindex")
    }
  }

  close() {
    if (this.parentPreventingFocus) {
      this.parentPreventingFocus.setAttribute("tabindex", -1)
    }
  }

  findParentPreventingFocus() {
    let parent = this.element.parentNode

    while (parent) {
      if (typeof parent.getAttribute !== "function") return null

      if (parent.getAttribute("tabindex") === "-1") return parent

      parent = parent.parentNode
    }

    return null
  }

  get customConfig() {
    // On mobile user agents flatpickr hides our input and inserts a native
    // <input type="time">, which renders in the device's locale (24-hour when the
    // device is set that way) and ignores `minuteIncrement`. Keep our own picker
    // everywhere so the format matches what the server asked for. Views can still
    // opt out with `data-flatpickr-disable-mobile="false"`.
    const base = { disableMobile: true }

    if (this.timeStartValue) {
      return {
        ...base,
        enableTime: true,
        dateFormat: "F d, Y H:i",
        maxDate: endOfToday(),
        defaultHour: 0,
        defaultMinute: 0,
      }
    } else if (this.timeEndValue) {
      return {
        ...base,
        enableTime: true,
        dateFormat: "F d, Y H:i",
        maxDate: endOfToday(),
        defaultHour: 23,
        defaultMinute: 59,
      }
    } else {
      return base
    }
  }
}
